var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('table-page-filters',{attrs:{"limit":_vm.limit,"columns":_vm.columns,"filters":_vm.filters,"attach-class":".surveys","cols-wax-width":354},on:{"submit":_vm.submitFilters,"clear":function($event){return _vm.$emit('clear')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }